/**
 * 组件添加前的校验。
 *
 * 设计：
 *  - 通用校验（type 是否已注册、几何配置缺字段、立牌必填 imageBorderParseParams）走本文件
 *  - type 专属校验通过 typeRegistry 调 strategy.validateGeometryConfig(geometryConfig)
 *    返回中文错误文案 / null
 *
 * 失败时本文件只**返回**错误文案，不 Toast；由 orchestrator 决定 Toast + throw。
 */

import { getComponentType } from './typeRegistry.js';

/**
 * 校验某个 type 的 geometryConfig。
 * @param {string} type
 * @param {Object} geometryConfig
 * @returns {string|null} 错误文案；null 表示通过
 *
 * @example
 * validateGeometryConfig('keyHole', { outerHoleDiameterMm: 6 })
 * // => '缺少组件尺寸配置：innerHoleDiameterMm'
 */
export function validateGeometryConfig(type, geometryConfig) {
  if (!geometryConfig || typeof geometryConfig !== 'object') {
    return '缺少组件尺寸配置：geometryConfig';
  }
  const strategy = getComponentType(type);
  if (!strategy) {
    return '组件类型未注册：' + type;
  }
  if (typeof strategy.validateGeometryConfig === 'function') {
    return strategy.validateGeometryConfig(geometryConfig);
  }
  // 该类型 type 策略尚未实现校验（阶段 2-4 时由对应 type 文件补齐）
  return '该类型校验暂未实现（开发中）：' + type;
}

/**
 * 校验 addComponent 全部 options。
 *
 * 注意：立牌的 `imageBorderParseParams` 校验由 orchestrator.addComponent 处理（既要
 * 能从 options 取，也能 fallback 到 sharedState.imageBorderParseParams，以支持
 * restoreComponents 不重复传），不放在本函数。
 *
 * @param {string} type
 * @param {Object} options
 * @param {Object} options.geometryConfig
 * @param {Object} [options.placement]
 * @returns {string|null} 错误文案；null 表示通过
 */
export function validateAddComponent(type, options) {
  if (!options || typeof options !== 'object') {
    return 'addComponent 缺少 options';
  }
  const geometryErr = validateGeometryConfig(type, options.geometryConfig);
  if (geometryErr) return geometryErr;
  return null;
}
